import React, { useEffect, useState } from "react";
import AcademyHead from "./AcademyHead";
import { IoClose } from "react-icons/io5";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { toast } from "react-toastify";
import Spinner from "../../components/spinner/Spinner";
import { parseStatics } from "../../function/parseStatics";

interface IArch {
  id?: string;
  logo: string;
  email: string;
  companyName: string;
  images: any;
  phone: string;
  address: string;
  about: string;
  status?: boolean;
}

const AcademyArchitecture: React.FC = () => {
  const [archs, setArchs] = useState<IArch[]>([]);
  const [selectedArch, setselectedArch] = useState<IArch | null>(null);
  const [showArchModal, setShowArchModal] = useState<boolean>(false);
  const [parsedImages, setParsedImages] = useState<any>();
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  // GET ARCHS
  useEffect(() => {
    const getArchs = async () => {
      setLoading(true);
      try {
        const response = await getFetcher(endpoints.eAcademy.getArchs);

        if (response.result) {
          setArchs(response.archs);
          setTimeout(() => {
            setLoading(false);
          }, 200);
        } else {
          toast.error("Error");
        }
      } catch (error) {
        console.log(error);
      }
    };
    getArchs();
  }, []);

  // SELECTED ARCH
  const handleSelectedArch = (arch: IArch) => {
    setselectedArch(arch);
    arch.images && setParsedImages(parseStatics(arch.images));
    setTimeout(() => {
      setShowArchModal(true);
    }, 300);
  };

  // CLICK IMAGE
  const handleClickImage = (image: string) => {
    setShowImageModal(true);
    setSelectedImage(image);
  };

  if (loading)
    return (
      <div>
        <Spinner />
      </div>
    );

  return (
    <div className=" flex flex-col gap-y-5 px-2">
      {/* HEAD */}
      <div>
        <AcademyHead title={"ECZA AKADEMİ MİMARİ"} />
      </div>

      {/* ARCHITECTURE */}
      <div className="h-full p-2 grid grid-cols-1  2xl:grid-cols-2 gap-10">
        {archs?.map((arch: IArch, i: number) => {
          return (
            <div
              onClick={() => handleSelectedArch(arch)}
              key={i}
              className=" h-[600px] sm:h-[400px] 2xl:h-[270px]  rounded-xl shadow-lg hover:shadow-2xl cursor-pointer transition-all transform active:scale-95 w-full "
            >
              <div className=" flex flex-col sm:flex-row gap-y-2 h-full">
                <div className="w-full h-full sm:w-1/3 flex justify-center items-center bg-gradient-to-b from-primary-color to-black rounded-t-xl sm:rounded-l-xl sm:rounded-t-none p-6">
                  <img
                    className="w-[120px] lg:w-[180px] h-[120px] lg:h-[180px] rounded-full object-contain shadow-xl"
                    src={arch.logo}
                    alt={arch.companyName}
                  />
                </div>

                <div className=" p-10 flex flex-col gap-y-4 flex-[2]">
                  <div className=" flex flex-col xl:flex-row gap-x-3 text-sm ">
                    <p className="min-w-20 lg:min-w-32">Şirket Adı:</p>
                    <p className=" font-bold">{arch.companyName}</p>
                  </div>
                  <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                    <p className="min-w-20 lg:min-w-32">Şirket Maili:</p>
                    <p className=" font-bold">{arch.email}</p>
                  </div>
                  <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                    <p className="min-w-20 lg:min-w-32">Şirket Telefonu:</p>
                    <p className=" font-bold">{arch.phone}</p>
                  </div>
                  <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                    <p className="min-w-20 lg:min-w-32">Şirket Adresi:</p>
                    <p className=" font-bold">{arch.address}</p>
                  </div>
                  <div className=" flex sm:px-10 flex-row gap-x-3 text-sm w-full justify-center sm:justify-end ">
                    <button className="mt-auto text-primary-color font-semibold">
                      Detaylar için tıklayınız
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* ARCH MODAL */}
      {showArchModal && (
        <div className="w-full h-full fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
          <div
            onClick={() => setShowArchModal(false)}
            className="w-full h-full absolute"
          ></div>

          <div
            className="w-11/12 lg:w-9/12 xl:w-11/12 h-5/6 bg-white flex flex-col justify-start items-start rounded-xl relative p-4 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Title */}
            <div className="w-full flex justify-center items-center mb-6">
              <h3 className="font-bold text-primary-color text-2xl text-center mt-4">
                {selectedArch?.companyName} Firmasının Mimari Tanıtımı
              </h3>
            </div>

            <div className=" flex flex-col  w-full justify-center items-center p-5 gap-y-2 xl:gap-y-5">
              {/* INFO */}
              <div className="flex flex-col xl:flex-row w-full h-full xl:h-[250px] justify-start sm:justify-center items-start sm:items-center xl:items-center gap-x-5 xl:gap-x-0">
                <div className="xl:flex-1 flex justify-center items-center h-full">
                  <img
                    src={selectedArch?.logo}
                    alt=""
                    className=" w-[100px] lg:w-[250px] h-[100px] lg:h-[250px] rounded-full lg:p-10 bg-primary-color object-contain"
                  />
                </div>

                <div className=" xl:flex-[1] flex flex-col h-full">
                  <div className=" p-1 flex flex-col gap-y-4 flex-[2] justify-start items-start  ">
                    <div className=" flex flex-col xl:flex-row gap-x-3 text-sm ">
                      <p className="min-w-20 xl:min-w-32">Şirket Adı:</p>
                      <p className=" font-bold">{selectedArch?.companyName}</p>
                    </div>
                    <div className=" flex flex-col xl:flex-row gap-x-3 text-sm ">
                      <p className="min-w-20 xl:min-w-32">Şirket Maili:</p>
                      <p className=" font-bold">{selectedArch?.email}</p>
                    </div>
                    <div className=" flex flex-col xl:flex-row gap-x-3 text-sm ">
                      <p className="min-w-20 xl:min-w-32">Şirket Telefonu:</p>
                      <p className=" font-bold">{selectedArch?.phone}</p>
                    </div>
                    <div className=" flex flex-col xl:flex-row gap-x-3 text-sm ">
                      <p className="min-w-20 xl:min-w-32">Şirket Adresi:</p>
                      <p className=" font-bold">{selectedArch?.address}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* ABOUT */}
              <div className="w-full h-full   p-3 bg-white shadow-xl rounded-xl">
                <h2 className=" font-bold text-primary-color text-xl flex justify-center">
                  Hakkında
                </h2>
                <p className=" h-full">{selectedArch?.about}</p>
              </div>

              {/* IMAGES */}
              <div className=" flex gap-x-20 gap-y-2 lg:gap-y-5 flex-wrap justify-center w-full">
                {parsedImages.map((image: string, i: number) => {
                  return (
                    <div
                      key={i}
                      className=" h-[250px] border p-2 rounded-xl bg-gray-200 w-[200px] flex justify-center items-center shadow-lg cursor-pointer "
                      onClick={() => handleClickImage(image)}
                    >
                      <img
                        src={image}
                        alt=""
                        className=" h-full w-full rounded-xl"
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Close Button */}
            <div className="absolute top-2 right-2">
              <IoClose
                onClick={() => setShowArchModal(false)}
                className="text-primary-color text-2xl cursor-pointer"
              />
            </div>
          </div>
        </div>
      )}
      {/* IMAGE MODAL */}
      {showImageModal && (
        <div
          onClick={() => setShowImageModal(false)}
          className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
        >
          <div
            className="w-full h-full absolute"
            onClick={() => setShowImageModal(false)}
          ></div>

          <div
            className="relative w-full max-w-3xl h-1/2"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              className="w-full h-full rounded-lg object-contain"
              src={selectedImage && selectedImage}
              alt="Full-size Image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AcademyArchitecture;
